module.exports = __webpack_public_path__ + "img/stema.b0e9fafe.jpg";